// class PredictiveSearch extends HTMLElement {
//   constructor() {
//     super();
//     this.input = this.querySelectorAll('input[type="search"]');
//     this.results = this.querySelectorAll('[data-predictive-search]');
//     this.abortController = null;
//     const searchIcon = this.querySelector('.fa.fa-search');
//     this.mobileDrawer = document.querySelector('[data-mobile-search]');
//     this.mobileOpenBtn = document.querySelector('[data-mobile-search-open]');
//     this.mobileCloseBtn = document.querySelector('[data-mobile-search-close]');


//     this.input.forEach(element => {
//         element.addEventListener('input', this.onChange.bind(this));
//     });
//     // this.input.addEventListener('blur', this.onBlur.bind(this));
//     // this.input.addEventListener('focus', this.onFocus.bind(this));
//     searchIcon.addEventListener('click', this.onClickSearch.bind(this));

//     if (this.mobileDrawer && this.mobileOpenBtn) {
//     this.mobileOpenBtn.addEventListener('click', () => this.openMobileDrawer());
//     }

//     if (this.mobileDrawer && this.mobileCloseBtn) {
//     this.mobileCloseBtn.addEventListener('click', () => this.closeMobileDrawer());
//     }
//   }

//   openMobileDrawer() {
//     this.mobileDrawer.classList.add('is-active');
//     document.body.style.overflow = 'hidden';

//     setTimeout(() => {
//             this.input.focus();
//         }, 150);
//     }

//     closeMobileDrawer() {
//         this.mobileDrawer.classList.remove('is-active');
//         document.body.style.overflow = '';
//         this.clearResults();
//         this.input.value = '';
//     }


//   onChange() {
//     clearTimeout(this.debounceTimer);

//     this.debounceTimer = setTimeout(() => {
//       const query = this.input.value.trim();

//       if (query.length === 0) {
//         this.clearResults();
//         return;
//       }

//     //   if (query.length < 2) {
//     //     return;
//     //   }

//       this.getResults(query);
//     }, 250);
//   }

//   onClickSearch(event) {
//     event.preventDefault();

//     const query = this.input.value.trim();

//     if (!query) {
//         this.input.focus();
//         return;
//     }

//     const searchUrl = `/search?type=product&q=${encodeURIComponent(query)}`;

//     // window.open(searchUrl, '_blank');
//      window.location.href = searchUrl;
//     }



//   getResults(query) {
//     if (this.abortController) {
//         this.abortController.abort();
//     }

//     this.abortController = new AbortController();

//     fetch(
//         `${Shopify.routes.root}search/suggest?q=${encodeURIComponent(query)}&resources[type]=product,article,page,collection&resources[limit]=5&section_id=predictive-search`,
//         { signal: this.abortController.signal }
//     )
//         .then((response) => response.text())
//         .then((html) => {
//         const parser = new DOMParser();
//         const doc = parser.parseFromString(html, 'text/html');
            
//         const hasResults =
//             doc.querySelectorAll(
//             '.predictive-search__product, .predictive-search__item, .predictive-search__collection'
//             ).length > 0;
            

//         if (!hasResults) {
//             this.results.innerHTML = `
//             <div class="predictive-search__empty">
//                 Empty results
//             </div>
//             `;
//         } else {
//             this.results.innerHTML = html;
//         }

//         this.results.hidden = false;
//         })
//         .catch((error) => {
//         if (error.name === 'AbortError') return;
//         console.error('Predictive search error:', error);
//         });
//     }



//   clearResults() {
//     this.results.innerHTML = '';
//     this.results.hidden = true;
//   }

//   onBlur() {
//     setTimeout(() => this.clearResults(), 200);
//   }

//   onFocus() {
//     if (this.results.innerHTML.trim() !== '') {
//       this.results.hidden = false;
//     }
//   }


// }

// customElements.define('predictive-search', PredictiveSearch);

class PredictiveSearch extends HTMLElement {
  constructor() {
    super();

    /* ===============================
       ELEMENTS
    =============================== */
    this.inputs = this.querySelectorAll('input[type="search"]');
    this.results = this.querySelectorAll('[data-predictive-search]');
    this.searchIcon = this.querySelector('.fa.fa-search');

    this.mobileDrawer = document.querySelector('[data-mobile-search]');
    this.mobileOpenBtn = document.querySelector('[data-mobile-search-open]');
    this.mobileCloseBtn = document.querySelector('[data-mobile-search-close]');

    this.abortController = null;
    this.debounceTimer = null;

    /* ===============================
       EVENTS
    =============================== */
    this.inputs.forEach(input => {
      input.addEventListener('input', this.onChange.bind(this));
      input.addEventListener('keydown', (e) => {
        if (e.key === 'Enter') {
          e.preventDefault();
          this.redirectToSearch(input.value);
        }
      });
    });

    if (this.searchIcon) {
      this.searchIcon.addEventListener('click', (e) => {
        e.preventDefault();
        const activeInput =
          [...this.inputs].find(i => i === document.activeElement) || this.inputs[0];
        this.redirectToSearch(activeInput.value);
      });
    }

    if (this.mobileOpenBtn && this.mobileDrawer) {
      this.mobileOpenBtn.addEventListener('click', () => this.openMobileDrawer());
    }

    if (this.mobileCloseBtn && this.mobileDrawer) {
      this.mobileCloseBtn.addEventListener('click', () => this.closeMobileDrawer());
    }
  }

  /* ===============================
     INPUT CHANGE
  =============================== */
  onChange(event) {
    clearTimeout(this.debounceTimer);

    const query = event.target.value.trim();

    this.debounceTimer = setTimeout(() => {
      if (!query) {
        this.clearResults();
        return;
      }

      this.getResults(query);
    }, 250);
  }

  /* ===============================
     FETCH PREDICTIVE
  =============================== */
  getResults(query) {
    if (this.abortController) {
      this.abortController.abort();
    }

    this.abortController = new AbortController();

    fetch(
      `${Shopify.routes.root}search/suggest?q=${encodeURIComponent(
        query
      )}&resources[type]=product,collection,article,page&resources[limit]=5&section_id=predictive-search`,
      { signal: this.abortController.signal }
    )
      .then(res => res.text())
      .then(html => {
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');

        const hasResults = doc.querySelectorAll(
          '.predictive-search__product, .predictive-search__collection, .predictive-search__item'
        ).length > 0;

        if (!hasResults) {
          this.updateResults(`
            <div class="predictive-search__empty">
              No results found
            </div>
          `);
        } else {
          this.updateResults(html);
        }
      })
      .catch(error => {
        if (error.name === 'AbortError') return;
        console.error('Predictive search error:', error);
      });
  }

  /* ===============================
     UPDATE / CLEAR RESULTS
  =============================== */
  updateResults(html) {
    this.results.forEach(result => {
      result.innerHTML = html;
      result.hidden = false;
    });
  }

  clearResults() {
    this.results.forEach(result => {
      result.innerHTML = '';
      result.hidden = true;
    });
  }

  /* ===============================
     REDIRECT SEARCH PAGE
  =============================== */
  redirectToSearch(value) {
    const query = value.trim();
    if (!query) return;

    window.location.href = `/search?type=product&q=${encodeURIComponent(query)}`;
  }

  /* ===============================
     MOBILE DRAWER
  =============================== */
  openMobileDrawer() {
    this.mobileDrawer.classList.add('is-active');
    document.body.style.overflow = 'hidden';

    const mobileInput = this.mobileDrawer.querySelector('input[type="search"]');
    if (mobileInput) {
      setTimeout(() => mobileInput.focus(), 150);
    }
  }

  closeMobileDrawer() {
    this.mobileDrawer.classList.remove('is-active');
    document.body.style.overflow = '';

    this.inputs.forEach(input => (input.value = ''));
    this.clearResults();
  }
}

customElements.define('predictive-search', PredictiveSearch);
